import * as Yup from 'yup';

const assetStepSchema = Yup.object().shape({
  firstTimeFiler: Yup.boolean().required(),
  assets: Yup.array().when('firstTimeFiler', {
    is: true, // when firstTimeFiler is true
    then: Yup.array().required().min(1), // assets is required and must have at least one item
    otherwise: Yup.array().notRequired(), // assets is not required when firstTimeFiler is false
  }),
});

export default assetStepSchema;
